import * as u from "react";
import { g as c, c as f } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { g as w } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { u as F } from "./useFormControl-C9UMlaFq.mjs";
import { f as x } from "./formControlState-vgaj2ksH.mjs";
import { j as C } from "./jsx-runtime-3tyXYecC.mjs";
import { s as G, u as y, c as R } from "./DefaultPropsProvider-CFfEbxdP.mjs";
function d(o) {
  return c("MuiFormGroup", o);
}
w("MuiFormGroup", ["root", "row", "error"]);
const g = (o) => {
  const {
    classes: r,
    row: s,
    error: t
  } = o;
  return R({
    root: ["root", s && "row", t && "error"]
  }, d, r);
}, v = G("div", {
  name: "MuiFormGroup",
  slot: "Root",
  overridesResolver: (o, r) => {
    const {
      ownerState: s
    } = o;
    return [r.root, s.row && r.row];
  }
})({
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap",
  variants: [{
    props: {
      row: !0
    },
    style: {
      flexDirection: "row"
    }
  }]
}), h = /* @__PURE__ */ u.forwardRef(function(r, s) {
  const t = y({
    props: r,
    name: "MuiFormGroup"
  }), {
    className: e,
    row: n = !1,
    ...m
  } = t, i = F(), l = x({
    props: t,
    muiFormControl: i,
    states: ["error"]
  }), a = {
    ...t,
    row: n,
    error: l.error
  }, p = g(a);
  return /* @__PURE__ */ C.jsx(v, {
    className: f(p.root, e),
    ownerState: a,
    ref: s,
    ...m
  });
});
export {
  h as F
};
//# sourceMappingURL=FormGroup-JbpzXay2.mjs.map
